export const SIGNAL_NEO_STATUS = {
  IDLE: 'idle',
  QUEUED: 'queued',
  RUNNING: 'running',
  COMPLETED: 'completed',
} as const;

export type SignalNeoStatus =
  (typeof SIGNAL_NEO_STATUS)[keyof typeof SIGNAL_NEO_STATUS];

const RUNNING_NEO_ATTACK_STATES = new Set(['running', 'starting']);

export const resolveSignalNeoStatus = ({
  attackStatus,
  isAttackRequestRunning,
}: {
  attackStatus: string | undefined;
  isAttackRequestRunning: boolean;
}): SignalNeoStatus => {
  if (attackStatus === SIGNAL_NEO_STATUS.QUEUED) {
    return SIGNAL_NEO_STATUS.QUEUED;
  }

  if (
    isAttackRequestRunning ||
    (attackStatus !== undefined && RUNNING_NEO_ATTACK_STATES.has(attackStatus))
  ) {
    return SIGNAL_NEO_STATUS.RUNNING;
  }

  return attackStatus === SIGNAL_NEO_STATUS.COMPLETED
    ? SIGNAL_NEO_STATUS.COMPLETED
    : SIGNAL_NEO_STATUS.IDLE;
};

export const isSignalNeoBusy = (status: SignalNeoStatus) =>
  status === SIGNAL_NEO_STATUS.QUEUED || status === SIGNAL_NEO_STATUS.RUNNING;
